export enum TaskStatusAction {
    REJECT = 'REJECT',
    CREATE_AD_HOC_TASK = 'CREATE_AD_HOC_TASK',
}
